import DeviceDetector from "../../components/deviceDetector";

export default class Calendar {
    constructor(flatpickr, flatpickrLangs, id, domElement, positionElement, functionOnChangeDates, functionOnClose, functionOnOpen, functionInitializeView,  locale = 'es', disabledDates = [], functionOnDayCreate = () => {}) {
        this.flatpickr = flatpickr;
        this.flatpickrLangs = flatpickrLangs;
        this.id = id;
        this.deviceDetector = new DeviceDetector;
        this.domElement = domElement;
        this.positionElement = positionElement;
        this.functionOnChangeDates = functionOnChangeDates;
        this.functionOnClose = functionOnClose;
        this.functionOnOpen = functionOnOpen;
        this.functionInitializeView = functionInitializeView;
        this.locale = locale;
        this.disabledDates = disabledDates
        this.functionOnDayCreate = functionOnDayCreate;
        this.initialize();
    }

    initialize() {
        this.isMobileView = this.deviceDetector.checkScreenBreakpoint('lg');
        this.config = {
            showMonths: this.getShowMonths(),
            minDate: this.getDefaultMinDate(),
            disable: this.disabledDates,
            mode: 'range',
            disableMobile: "true",
            altInput: true,
            altFormat: "j M Y",
            dateFormat: "j M Y",
            locale: {
                rangeSeparator: ' - ',

            },
            prevArrow: "<i class='fa fa-lg fa-chevron-left'></i>",
            nextArrow: "<i class='fa fa-lg fa-chevron-right'></i>",
            monthSelectorType: 'static',
            positionElement: this.positionElement,
            closeOnSelect: false,
            onDayCreate: this.functionOnDayCreate,
        };
        this.flatpickr.localize(this.getLocalizeFromLocale());

        this.element = this.flatpickr(this.domElement, this.config);
        this.setOnChangeDates(this.functionOnChangeDates)
        this.setOnClose(this.functionOnClose);
        this.setOnOpen(this.functionOnOpen);
        this.element.calendarContainer.setAttribute('data-calendar-container', this.id);
        this.functionInitializeView();
        this.setView();

        window.addEventListener('resize', () => {
            this.deviceDetector.detectWindowWidth();
            let mobileView = this.deviceDetector.checkScreenBreakpoint('lg');
            if (this.isMobileView !== mobileView) {
                this.isMobileView = mobileView;
                this.element.set('showMonths', this.getShowMonths());
                setTimeout(() => {
                    this.setView();
                }, 200);

            }
        });
    }

    setView() {
        if(!this.isMobileView) {
            return;
        }

        let daysArray = document.querySelectorAll('.dayContainer');
        let monthArray = document.querySelectorAll('.flatpickr-month');
        let weekDaysContainer = document.querySelectorAll('.flatpickr-weekdaycontainer');

        daysArray.forEach((element, key) => {
            monthArray[key].style.top = (element.offsetTop) +'px';
            weekDaysContainer[key].style.top = (element.offsetTop + monthArray[key].offsetHeight) +'px';
        });

        let startRange = this.element.daysContainer.querySelector('.startRange');

        if (startRange && startRange.parentElement && startRange.parentElement.previousElementSibling){
            let daysPrevMonth = startRange.parentElement.previousElementSibling.querySelectorAll('.flatpickr-day');
            if (daysPrevMonth) {
                let monthToScroll = daysPrevMonth[daysPrevMonth.length - 1];
                if (monthToScroll !== undefined) {
                    monthToScroll.scrollIntoView();
                }
            }
        }
    }

    getShowMonths() {
        return this.isMobileView ? 24 : 2;
    }

    getLocalizeFromLocale() {
        switch (this.locale) {
            case 'es':
                return this.flatpickrLangs.Spanish;
            case 'ca':
                return this.flatpickrLangs.Catalan;
            case 'en':
                return 'en';
            case 'fr':
                return this.flatpickrLangs.French;
            case 'pt':
                return this.flatpickrLangs.Portuguese;
            case 'de':
                return this.flatpickrLangs.German;
            case 'it':
                return this.flatpickrLangs.Italian;
            default:
                return this.flatpickrLangs.Spanish;
        }
    }

    getDefaultMinDate() {
        let currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);

        this.disabledDates.forEach((element) => {
            let from = new Date(element.from);
            let to = new Date(element.to);
            from.setHours(0, 0, 0, 0);
            to.setHours(0, 0, 0, 0);
            if (currentDate >= from && currentDate <= to) {
                currentDate = to;
            }
        });

        let dateTextCET = currentDate.toLocaleString(
            "en-US",
            {timeZone: "Europe/Madrid", month: 'numeric', day: 'numeric', year: 'numeric'}
        );
        return new Date(dateTextCET);
    }

    setDate(date) {
        this.element.setDate(date, false);
    }

    setMinDate(date) {
        this.element.config.minDate = date;
    }

    setMaxDate(date) {
        this.element.config.maxDate = date;
    }

    setOnChangeDates(functionOnChangeDates) {
        this.element.config.onChange = [functionOnChangeDates];
    }

    setOnOpen(functionOnOpen) {
        this.element.config.onOpen = [functionOnOpen];
    }

    setOnClose(functionOnClose) {
        this.element.config.onClose = [functionOnClose];
    }

    open() {
        this.element.open();
    }

    close() {
        this.element.close();
    }

    toggle() {
        this.element.toggle();
    }
    redraw() {
        this.element.redraw();
    }
    jumpToDate(date) {
        this.element.jumpToDate(date, true)
    }
    updateMonthView() {
        let calendarContainer = document.querySelector('[data-calendar-container="booking-dates"]')
        let daysArray = calendarContainer.querySelectorAll('.dayContainer');
        let monthArray = calendarContainer.querySelectorAll('.flatpickr-month');
        let weekDaysContainer = calendarContainer.querySelectorAll('.flatpickr-weekdaycontainer');
        let calendarOptionsContainerHeight = document.querySelector('[data-type="any-dates-container"]').offsetHeight;

        daysArray.forEach((element, key) => {
            let date = new Date(element.querySelector('.flatpickr-day:not(.hidden)').getAttribute('aria-label'));
            let currentMonth = myApp.dateFormatter.getShortDate(date, '/', true);
            element.setAttribute('data-entity', currentMonth);
            monthArray[key].style.top = (element.offsetTop + calendarOptionsContainerHeight) + 'px';
            weekDaysContainer[key].style.top = (element.offsetTop + monthArray[key].offsetHeight + calendarOptionsContainerHeight) +'px';
        });
    }
}
